module.exports = __webpack_public_path__ + "img/n3.06dee937.png";